export const DEFAULT_POLL_INTERVAL_MS = 10_000;
export const MIN_POLL_INTERVAL_SECONDS = 1;
export const DEFAULT_MAX_VISIBLE_PHOTOS = 10;
export const MIN_MAX_VISIBLE_PHOTOS = 1;
export const MAX_MAX_VISIBLE_PHOTOS = 50;

export function pollIntervalMsToSeconds(ms: number | null | undefined): number {
  if (typeof ms !== 'number' || !Number.isFinite(ms) || ms <= 0) {
    return DEFAULT_POLL_INTERVAL_MS / 1000;
  }
  return Math.round(ms / 1000);
}

export function secondsToPollIntervalMs(seconds: number): number {
  return Math.max(MIN_POLL_INTERVAL_SECONDS, Math.round(seconds)) * 1000;
}

export function resolveMaxVisiblePhotos(
  value: number | null | undefined,
): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return DEFAULT_MAX_VISIBLE_PHOTOS;
  }
  return Math.min(
    MAX_MAX_VISIBLE_PHOTOS,
    Math.max(MIN_MAX_VISIBLE_PHOTOS, Math.round(value)),
  );
}
